import React, { useEffect, useState } from 'react'
import Drawer from 'src/components/ui/Drawer'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box, FormControl, FormHelperText, Grid } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import yup from 'src/components/yupCustom'
import Button from 'src/components/ui/Button'
import Swal from 'sweetalert2'
import CurrencyInput from 'src/components/ui/CurrencyInput'
import { obterValorDiariaUti, salvarValorDiariaUti } from 'src/api/acomodacao'

type Props = {
  open: boolean
  handleOnClose: () => void
}

const contactSchema = yup.object().shape({
  valor: yup.number().min(0).required().label('Valor')
})

function DrawerSalvarValorUti({ open, handleOnClose }: Props) {
  const [loading, setLoading] = useState(false)
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false)

  const {
    watch,
    register,
    setValue,
    errors,
    control,
    handleSubmit,
    trigger
  } = useForm<{ valor: number }>({
    mode: 'onChange',
    resolver: yupResolver(contactSchema),
    defaultValues: { valor: 0 }
  })

  const command = watch()

  useEffect(() => {
    register('valor')
  }, [register])

  async function buscarValorAtual() {
    setLoading(true)
    try {
      const response = await obterValorDiariaUti()
      if (response.data && response.data.valor) {
        const valorNumerico = parseFloat(response.data.valor)
        if (!isNaN(valorNumerico)) {
          setValue('valor', Math.round(valorNumerico * 100), { shouldValidate: true })
        }
      } else {
        setValue('valor', 0, { shouldValidate: true })
      }
    } catch (error) {
      setValue('valor', 0, { shouldValidate: true })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      buscarValorAtual()
    }
  }, [open])

  const onSubmit = async data => {
    try {
      setLoadingSubmitButton(true)
      const payload = {
        valor: (data.valor || 0) / 100
      }

      await salvarValorDiariaUti(payload.valor)

      Swal.fire({
        title: 'Sucesso!',
        text: 'Valor padrão da diária de UTI salvo com sucesso!',
        icon: 'success',
        confirmButtonText: 'Ok'
      }).then(() => {
        handleOnClose()
      })
    } catch (error) {
      showNotificationErrorAPI(error)
    } finally {
      setLoadingSubmitButton(false)
    }
  }

  function handleChangeValor(key: 'valor', value: number): void {
    setValue(key, value, { shouldValidate: true })
  }

  return (
    <Drawer
      handleOnClose={handleOnClose}
      open={open}
      titulo="Configurar valor da diária de UTI"
      loading={loading}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <FormControl fullWidth variant="outlined">
              <CurrencyInput
                label="Valor da diária"
                name="valor"
                erro={errors}
                variant="outlined"
                control={control}
                InputLabelProps={{ shrink: true }}
                autoFocus
                placeholder="R$ 0,00"
                onValueChange={value => handleChangeValor('valor', value)}
                value={command?.valor || 0}
              />
              <FormHelperText error={!!errors?.valor}>
                {errors?.valor?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        <Box display="flex" justifyContent="flex-end" mt={2} mb={5}>
          <Box mr={1}>
            <Button
              onClick={handleOnClose}
              variant="outlined"
              color="primary"
              disabled={loadingSubmitButton}
            >
              Cancelar
            </Button>
          </Box>
          <Box>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              loading={loadingSubmitButton}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      </form>
    </Drawer>
  )
}

export default DrawerSalvarValorUti
